import FeatureGates from '@atlaskit/feature-gate-js-client';
import { Cohort } from '../../../types';
export var getFrontendExperiment = function getFrontendExperiment(_ref) {
  var abTestId = _ref.abTestId;
  var cohort = FeatureGates.getExperiment(abTestId).get('cohort', Cohort.Default);
  var serveExperiment = cohort === Cohort.Test;
  return {
    serveExperiment: serveExperiment,
    abTestId: abTestId,
    cohort: cohort
  };
};
export var serveFrontendExperiment = function serveFrontendExperiment(abTestId, frontendExperiments) {
  var _frontendExperiments$;
  if (!frontendExperiments) {
    return false;
  }
  return Boolean((_frontendExperiments$ = frontendExperiments[abTestId]) === null || _frontendExperiments$ === void 0 ? void 0 : _frontendExperiments$.serveExperiment);
};